import {all} from 'redux-saga/effects';
import DoctorDashboardSagas from "../doctor-dashboard/store/doctor-dashboard.sagas";
import RemotePatientMonitoringSignInSagas from "../app/remote-patient-monitoring-signin/store/remote-patient-monitoring-signin.sagas";

export default function* rootSaga() {
    yield all([
        DoctorDashboardSagas(),
        RemotePatientMonitoringSignInSagas(),
    ]);
}